import { ArrowLeftOutlined } from '@ant-design/icons';
import { useGo, useResourceParams } from '@refinedev/core';
import { Button } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { ResourcePermissionAction, usePermissionContext } from '@/contexts/PermissionContext';
import { useUserContext } from '@/contexts/UserContext';

import SpinLoading from '../general/SpinLoading';

interface ProtectedRoutesProps {
  children: React.ReactNode;
}

const ProtectedRoutes = (props: ProtectedRoutesProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const go = useGo();
  const { action, resource, id } = useResourceParams();
  const { isLoading } = useUserContext();
  const { hasPermission } = usePermissionContext();

  useEffect(() => {
    if (!isLoading && action == 'edit' && !hasPermission(action as ResourcePermissionAction)) {
      if (hasPermission('show') && resource && id) {
        go({ to: { resource: resource.name, action: 'show', id: id }, type: 'replace' });
      }
    }
  }, [isLoading, action, hasPermission, navigate, resource, id, go]);

  return (
    <>
      {isLoading ? (
        <SpinLoading />
      ) : action && !hasPermission(action as ResourcePermissionAction) ? (
        <div style={{ padding: '16px', textAlign: 'center' }}>
          <h2>{t('No tienes permiso para acceder a este recurso')}.</h2>
          <Button icon={<ArrowLeftOutlined />} onClick={() => void navigate(-1)}>
            {t('Volver')}
          </Button>
        </div>
      ) : (
        props.children
      )}
    </>
  );
};

export default ProtectedRoutes;
